(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/account-selector/assets/javascripts/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/syndicate/account-selector/assets/javascripts/handlebars-helpers.js');

(function() {
  'use strict';

  if (svs.isServer) {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('isActiveAccount', function(accountId, options) {
      return accountId === svs.syndicate.AccountSelector.getActiveAccountId() ? options.fn(this) : options.inverse(this);
    });
  }
})();


 })(window);